import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { printMintDate } from "@/helpers/Helpers";
interface NowMintingDetailsAccordionProps {
  readonly mintDate: Date | undefined;
  readonly fileType: string;
  readonly dimensions: string;
  readonly collection: string;
  readonly season: number;
}
export default function NowMintingDetailsAccordion(t0) {
  const $ = _c(21);
  const {
    mintDate,
    fileType,
    dimensions,
    collection,
    season
  } = t0;
  let t1;
  if ($[0] !== mintDate) {
    t1 = printMintDate(mintDate);
    $[0] = mintDate;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      label: "Mint date",
      value: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== fileType) {
    t3 = {
      label: "File type",
      value: fileType
    };
    $[4] = fileType;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== dimensions) {
    t4 = {
      label: "Dimensions",
      value: dimensions
    };
    $[6] = dimensions;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== collection) {
    t5 = {
      label: "Collection",
      value: collection
    };
    $[8] = collection;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = `SZN${season}`;
  let t7;
  if ($[10] !== t6) {
    t7 = {
      label: "Season",
      value: t6
    };
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t7) {
    t8 = [t2, t3, t4, t5, t7];
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const details = t8;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <summary className="tw-flex tw-cursor-pointer tw-items-center tw-justify-between tw-gap-2 tw-font-medium tw-text-sm tw-text-iron-400 desktop-hover:hover:tw-text-iron-50 tw-transition-colors tw-duration-300"><span>Edition Details</span><ChevronRightIcon className="tw-size-4 tw-transition-transform group-open:tw-rotate-90" /></summary>;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== details) {
    t10 = <details className="tw-group tw-border-b tw-border-solid tw-border-x-0 tw-border-t tw-border-iron-800 tw-pb-6 tw-pt-6">{t9}<div className="tw-mt-4 tw-pb-4"><div className="tw-space-y-3 tw-text-sm">{details.map(_temp)}</div></div></details>;
    $[19] = details;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}
function _temp(t0) {
  const {
    label,
    value
  } = t0;
  return <div key={label} className="tw-flex tw-justify-between"><span className="tw-text-iron-500">{label}</span><span className="tw-text-iron-100">{value}</span></div>;
}